import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Bridge component placé sur les pages nécessitant une authentification.
// Signale à iOS que l'utilisateur n'est pas connecté — permet d'afficher
// un modal d'authentification natif plutôt que la page sign_in inline.
export default class extends BridgeComponent {
  static component = 'auth-gate'

  connect() {
    super.connect()
    this.send('require')
  }
}
